<template>
  <div
    v-scroll="setHeight"
    class="overflow-auto"
    v-bind:style="disabled ? {} : { position: 'sticky', 'max-height': h, top }"
  >
    <slot></slot>
  </div>
</template>


<script>
export default {
  name: 'sticky-scroll',

  props: {
    top: { type: String, default: '0' },
    disabled: Boolean
  },

  data() {
    return {
      h: 0
    };
  },

  mounted() {
    this.setHeight();
  },

  methods: {
    setHeight() {
      this.h = `calc(100vh - ${this.$el.offsetTop - window.scrollY}px)`;
    }
  }
};
</script>
